import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Pressable } from 'react-native';
import { BodyText, HeaderText } from '../../ui';
import { GiftBoxIcon } from '../../ui/Icons';
import analytics from '../../../modules/analytics';
import { ShakeAnimatedView } from '../referrals/ShakeAnimatedView';

export const ReferralEntryTrigger = ({
  onClick,
  appearance = 'normal',
}: {
  onClick: () => void;
  appearance?: 'normal' | 'header';
}) => {
  const iconSize = appearance === 'normal' ? 12 : 16;

  const handleClick = () => {
    analytics.track('client_header_referral_entry_clicked');
    onClick();
  };

  return (
    <Pressable onPress={handleClick} testID="client-header-referral-entry">
      <Inline
        paddingX={12}
        paddingY={4}
        borderRadius={20}
        color={BrandColor.LightRed}
        alignItems="center"
      >
        <ShakeAnimatedView>
          <Box paddingRight={4}>
            <GiftBoxIcon height={iconSize} width={iconSize} />
          </Box>
        </ShakeAnimatedView>
        {appearance === 'normal' && (
          <BodyText
            weight="bold"
            testID="client-header-referral-entry-text"
          >Get $50
          </BodyText>
        )}
        {appearance === 'header' && (
          <Box
            paddingTop={4}
          >
            <HeaderText
              testID="client-header-referral-entry-text"
              level={3}
            >
              Get $50
            </HeaderText>
          </Box>
        )}
      </Inline>
    </Pressable>
  );
};
